"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useCallback, useId } from "react";
import { LotShipmentDetails } from "@/components/inventory/shipment-picker/lot-shipment-details";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { LotSelectionContext, LotSelectionRow, LotSelectionRowProvider, LotSelectionValue, useLotSelection } from "./lot-selection-context";
import { LotSelectionDepletedToggle, LotSelectionSearch } from "./lot-selection-controls";
function Provider(t0) {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <LotSelectionContext value={value}>{children}</LotSelectionContext>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function Frame(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    meta
  } = useLotSelection();
  let t1;
  if ($[0] !== children || $[1] !== meta.listId) {
    t1 = <div id={meta.listId} className="space-y-3" onKeyDown={_temp}>{children}</div>;
    $[0] = children;
    $[1] = meta.listId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(event) {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") {
    return;
  }
  const scope = (event.target as HTMLElement).closest("section") ?? event.currentTarget;
  const choices = Array.from(scope.querySelectorAll("[data-lot-picker-choice]:not(:disabled)"));
  const index = choices.indexOf(event.target as HTMLButtonElement);
  if (index < 0 || !choices.length) {
    return;
  }
  event.preventDefault();
  choices[(index + (event.key === "ArrowDown" ? 1 : -1) + choices.length) % choices.length].focus();
}
function Search() {
  const $ = _c(4);
  const {
    state,
    actions,
    meta
  } = useLotSelection();
  let t0;
  if ($[0] !== actions.setSearch || $[1] !== meta.listId || $[2] !== state.search) {
    t0 = <LotSelectionSearch value={state.search} onChange={actions.setSearch} listId={meta.listId} />;
    $[0] = actions.setSearch;
    $[1] = meta.listId;
    $[2] = state.search;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function DepletedToggle() {
  const $ = _c(3);
  const {
    state,
    actions
  } = useLotSelection();
  let t0;
  if ($[0] !== actions.setShowDepleted || $[1] !== state.showDepleted) {
    t0 = <LotSelectionDepletedToggle checked={state.showDepleted} onChange={actions.setShowDepleted} />;
    $[0] = actions.setShowDepleted;
    $[1] = state.showDepleted;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function SelectedSection(t0) {
  const $ = _c(5);
  const {
    children,
    showHeading: t1
  } = t0;
  const showHeading = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== showHeading) {
    t2 = showHeading && <h3 className="text-caption-strong">Lots</h3>;
    $[0] = showHeading;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <section aria-label="Lots" className="max-h-[min(420px,45dvh)] overflow-y-auto">{t2}{children}</section>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function AvailableSection(t0) {
  const $ = _c(9);
  const {
    children,
    showHeading: t1
  } = t0;
  const showHeading = t1 === undefined ? true : t1;
  const {
    state
  } = useLotSelection();
  let t2;
  if ($[0] !== showHeading) {
    t2 = showHeading && <h3 className="text-caption-strong">Inventory lots</h3>;
    $[0] = showHeading;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== state.available.length || $[3] !== state.selected) {
    t3 = !state.available.length && <p className="text-caption text-foreground-secondary">{state.selected.length ? "No other matching inventory lots" : "No matching inventory lots"}</p>;
    $[2] = state.available.length;
    $[3] = state.selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t3) {
    t4 = <section data-lot-picker-search-results={true} aria-label="Inventory lots" className="max-h-60 overflow-y-auto">{t2}{children}{t3}</section>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function Row(t0) {
  const $ = _c(35);
  const {
    row,
    children
  } = t0;
  const {
    state,
    actions,
    meta
  } = useLotSelection();
  const selectionId = useId();
  let t1;
  if ($[0] !== row.id || $[1] !== state.selected) {
    let t2;
    if ($[3] !== row.id) {
      t2 = candidate => candidate.id === row.id;
      $[3] = row.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = state.selected.some(t2);
    $[0] = row.id;
    $[1] = state.selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selected = t1;
  const revealControls = _temp2;
  let t2;
  if ($[5] !== actions || $[6] !== row.disabled || $[7] !== row.id || $[8] !== selected) {
    t2 = () => {
      if (row.disabled) {
        return;
      }
      if (selected) {
        actions.remove(row.id);
      } else {
        actions.select(row.id);
      }
    };
    $[5] = actions;
    $[6] = row.disabled;
    $[7] = row.id;
    $[8] = selected;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const toggle = t2;
  let t3;
  if ($[10] !== meta.selection || $[11] !== row.disabled || $[12] !== row.id || $[13] !== row.label || $[14] !== selected || $[15] !== selectionId || $[16] !== toggle) {
    t3 = meta.selection && <Checkbox id={selectionId} checked={selected} disabled={row.disabled} data-lot-picker-choice={true} aria-label={`${meta.selection.accessibleLabelPrefix} ${row.label} (${row.id})`} className="mt-0.5 border-border bg-background" onCheckedChange={toggle} onKeyDown={event => {
      if (event.key !== "Enter") {
        return;
      }
      event.preventDefault();
      toggle();
    }} />;
    $[10] = meta.selection;
    $[11] = row.disabled;
    $[12] = row.id;
    $[13] = row.label;
    $[14] = selected;
    $[15] = selectionId;
    $[16] = toggle;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const t4 = meta.selection ? selectionId : undefined;
  let t5;
  if ($[18] !== meta.locationNames || $[19] !== meta.productName || $[20] !== row.details || $[21] !== row.label) {
    t5 = row.details ? <LotShipmentDetails shipment={row.details} productName={meta.productName} locationNames={meta.locationNames} /> : <span className="text-body-strong">{row.label}</span>;
    $[18] = meta.locationNames;
    $[19] = meta.productName;
    $[20] = row.details;
    $[21] = row.label;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t4 || $[24] !== t5) {
    t6 = <Label htmlFor={t4} className="min-w-0 flex-1 font-normal">{t5}</Label>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t3 || $[27] !== t6) {
    t7 = <div className="flex items-start gap-3 px-2 py-1">{t3}{t6}</div>;
    $[26] = t3;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== children || $[30] !== selected) {
    t8 = selected && children && <div ref={revealControls}>{children}</div>;
    $[29] = children;
    $[30] = selected;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t7 || $[33] !== t8) {
    t9 = <div className="border-b border-border py-2 last:border-b-0">{t7}{t8}</div>;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}
function _temp2(node) {
  node?.scrollIntoView?.({
    block: "nearest"
  });
}
function SelectedRows(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    state
  } = useLotSelection();
  let t1;
  if ($[0] !== children || $[1] !== state.selected) {
    let t2;
    if ($[3] !== children) {
      t2 = row => <LotSelectionRowProvider key={row.id} value={row}><Row row={row}>{children}</Row></LotSelectionRowProvider>;
      $[3] = children;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = state.selected.map(t2);
    $[0] = children;
    $[1] = state.selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function AvailableRows() {
  const $ = _c(4);
  const {
    state
  } = useLotSelection();
  let t0;
  if ($[0] !== state.available) {
    t0 = state.available.map(_temp3);
    $[0] = state.available;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp3(row) {
  return <Row key={row.id} row={row} />;
}
export const LotSelection = {
  Provider,
  Frame,
  Search,
  DepletedToggle,
  SelectedSection,
  AvailableSection,
  SelectedRows,
  AvailableRows
};